import { notDesktop, styled, Text, useTranslation } from '@obvio/app'
import { Grid } from '@obvio/ui'

import { AboutPageMember } from './AboutPageMember'

import type { ReactElement } from 'react'

export const FullWidth = styled(Grid)`
  width: 100%;
  margin-top: ${(theme) => theme.spacing.extraLarge};
  @media ${notDesktop} {
    grid-template-columns: 1fr;
  }
`

export function BoardMembers(): ReactElement {
  const { t } = useTranslation()
  return (
    <>
      <Text tag="h2" as="h4">
        Artutito Board
      </Text>
      <AboutPageMember
        imgSrc="/static/images/Jakub-Fijewski.webp"
        thumb="L6HVF$8wlS0000E8NK~o00^+rDt7"
        name="Jakub Fijewski"
        title="Owner / Merchant"
        text={t('about.fijewski.description')}
      />
      {/** 
      <FullWidth templateColumns="1fr 1fr" gap="medium">
        <AboutPageMember
          imgSrc="/static/images/person1.png"
          thumb="LMJuM=~pX9Dj-:9aWX-pR%W?adoL"
          name="Jan Kowalski"
          title="Advisor"
          small
        />
        <AboutPageMember
          imgSrc="/static/images/person2.png"
          thumb="LMJuM=~pX9Dj-:9aWX-pR%W?adoL"
          name="Maria Kowalska"
          small
          title="Advisor"
        />
      </FullWidth>
			*/}
    </>
  )
}
